import { NavLink } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { usePermissions } from "../permissions/PermissionContext";
import NotificationGlocke from "./NotificationGlocke";
import Suche from "./Suche";

const nav = [
  { section: "Übersicht" },
  { to: "/", label: "Dashboard", icon: "⊞" },
  { to: "/mein-dashboard", label: "Mein Dashboard", icon: "★" },
  { section: "Sitzungen" },
  { to: "/sitzungen", label: "Alle Sitzungen", icon: "📋" },
  { to: "/sitzungen/neu", label: "Neue Sitzung", icon: "＋", permission: "sitzung.erstellen" },
  { to: "/kalender", label: "Kalender", icon: "📅" },
  { section: "Vorlagen" },
  { to: "/vorlagen", label: "Alle Vorlagen", icon: "📄" },
  { to: "/meine-mitzeichnungen", label: "Meine Mitzeichnungen", icon: "✎" },
  { section: "Beschlüsse" },
  { to: "/beschluesse", label: "Beschlussverfolgung", icon: "✓" },
  { section: "Verwaltung", adminOnly: true },
  { to: "/gremien", label: "Gremien", icon: "👥", adminOnly: true },
  { to: "/mitglieder", label: "Mitglieder", icon: "👤", adminOnly: true },
  { to: "/benutzer", label: "Benutzer", icon: "👥", adminOnly: true },
  { to: "/amtsperioden", label: "Amtsperioden", icon: "🗓", adminOnly: true },
  { to: "/buergerportal-einstellungen", label: "Bürgerportal-Zugang", icon: "🔒", adminOnly: true },
  { to: "/api-schluessel", label: "API-Schlüssel", icon: "🔑", adminOnly: true },
  { to: "/webhooks", label: "Webhooks", icon: "🔌", adminOnly: true },
  { to: "/admin/berechtigungen", label: "Gremium-Berechtigungen", icon: "🔐", permission: "admin.berechtigungen" },

  { to: "/einstellungen", label: "Einstellungen", icon: "⚙", adminOnly: true },
  { to: "/einstellungen/sso", label: "Single Sign-On", icon: "🔗", adminOnly: true },
  { section: "Konto" },
  { to: "/mein-konto", label: "Mein Konto", icon: "🔒" },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const { perms } = usePermissions();

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="logo-mark">
          <div className="emblem">F</div>
          <div>
            <h1>FFW Sitzungs&shy;management</h1>
          </div>
        </div>
      </div>

      <Suche />

      <nav className="sidebar-nav">
        {nav.map((item, i) => {
          if (item.adminOnly && !user?.isAdmin) return null;
          if (item.permission && !perms.has(item.permission) && !user?.isAdmin) return null;
          return item.section ? (
            <div key={i} className="nav-section">{item.section}</div>
          ) : (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) => `nav-item${isActive ? " active" : ""}`}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        {user && <NotificationGlocke />}
        {user && (
          <div style={{ marginBottom: 10 }}>
            <div style={{ color: "#ddd", fontWeight: 500, fontSize: 12 }}>{user.displayName}</div>
            <div style={{ color: "#555", fontSize: 11 }}>{user.email}</div>
            {user.isAdmin && (
              <div style={{ color: "var(--red)", fontSize: 10, marginTop: 2 }}>● Admin</div>
            )}
          </div>
        )}
        <button
          onClick={logout}
          style={{ background: "none", border: "1px solid #333", color: "#666",
                   padding: "4px 10px", borderRadius: 4, cursor: "pointer",
                   fontSize: 11, width: "100%", fontFamily: "var(--font)" }}>
          Abmelden
        </button>
      </div>
    </aside>
  );
}
